<template>
  <div class="auth-form">
    <div
      role="alert"
      aria-live="assertive"
      class="auth-form__full-width auth-form__error"
      :class="fontColor"
      ref="login-err"
    >
      {{ message }}
      <span class="auth-form__resend-verification-link" v-if="status['email_unverified']">
        Please click <a href="#" @click.prevent="resendAccountVerificationLink"> here</a> to resend
        verification link to your inbox.
        <span v-if="resendVerificationLoading" class="also-found__loading-spinner spinner"></span>
      </span>
      <span class="auth-form__send-reset-password-link" v-if="status['password_incorrect']">
        <a href="#" @click.prevent="sendResetPasswordLink"> Reset password? </a>
        <span v-if="passwordResetLoading" class="also-found__loading-spinner spinner"></span>
      </span>
    </div>

    <form @submit.prevent>
      <slot :email="email" :password="password" :update="update">
        <label for="email" class="auth-form__label">
          Email
          <input id="email" v-model="email" type="text" class="auth-form__input" />
        </label>

        <label for="password" class="auth-form__label">
          Password
          <input id="password" v-model="password" type="password" class="auth-form__input" />
        </label>
      </slot>
      <button @click="login" class="auth-form__input" type="submit">login</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'login',
  props: {
    demoEmail: {
      default: () => '',
      type: String,
    },
    demoPassword: {
      default: () => '',
      type: String,
    },
  },
  data() {
    return {
      email: null,
      password: null,
      message: null,
      status: {},
      passwordResetLoading: false,
      resendVerificationLoading: false,
      fontColor: '',
    };
  },
  created() {
    this.email = this.demoEmail;
    this.password = this.demoPassword;
  },
  methods: {
    async login() {
      this.status = {};

      try {
        this.message = null;

        await this.$pigeonline.login(this.email, this.password);
        this.fontColor = 'auth-form__success';
        this.message = 'Login Successful.';

        this.$emit('authenticated');
      } catch (e) {
        this.message = 'Unable to log you in.';
        //console.error(e);

        // handle email_unverified error
        const error = e.response && e.response.data;
        if (error && error.code) {
          if (error.detail) this.message = error.detail;
          this.status[error.code] = true;
        }

        this.$emit('error');
      }
    },
    update(field, val) {
      this[field] = val;
    },
    async resendAccountVerificationLink() {
      this.resendVerificationLoading = true;
      try {
        await this.$pigeonline.authService.resendAccountVerificationLink(this.email);
        this.message = 'A new verification email has been sent. Please check your inbox.';
        this.status['email_unverified'] = false;
      } catch (e) {
        //console.error(e);
        alert('There was an error processing your request. Please try again later.');
      }
      this.resendVerificationLoading = false;
    },
    async sendResetPasswordLink() {
      this.passwordResetLoading = true;
      try {
        await this.$pigeonline.authService.sendResetPasswordLink(this.email);
        this.message = 'An email has been sent to reset your password. Please check your inbox.';
        this.status['password_incorrect'] = false;
      } catch (e) {
        //console.error(e);
        alert('There was an error processing your request. Please try again later.');
      }
      this.passwordResetLoading = false;
    },
  },
};
</script>

<style src="./auth-styles.css"></style>
